import React, { Component } from 'react';
import companyService from '../../services/company';
import languageService from '../../services/language';
import searchService from '../../services/search';
import Articles from '../articles';
import './index.css';

export default class Search extends Component {
  state = {
    articles: null
  };

  onSearch(event) {
    const value = event.target.value;

    if (value) {
      const language = languageService.language;

      let query = {
        or: [
          { [`title${language}`]: { contains: value } },
          { [`secondTitleRo${language}`]: { contains: value } },
          { [`content${language}`]: { contains: value } }
        ]
      };

      searchService.dataWithQuery(query)
      .then(data => {
        this.setState({
          articles: data
        })
      });
    } else {
      this.setState({
        articles: []
      });
    }
  }

  render() {
    const placeholder = {
      'Ro': 'Exemplu: Declarații de avere, Drepturile pasagerilor, Cariere',
      'En': 'Example: Passenger information, Careers'
    }[languageService.language];

    const inputProps = {
      className: 'form-control',
      placeholder: placeholder,
      onChange: this.onSearch.bind(this)
    };

    return (
      <div className='comp-search  row'>
        <div className='col-md-12 p-0'>
          <input {...inputProps} />
        </div>

        <div className='col-md-12'>
          <Articles articlesFull={this.state.articles} />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/search/index.js